var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActiveAdmins(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5444 20.9778C17.5444 18.5765 19.4713 16.6299 21.8482 16.6299C24.2252 16.6299 26.1521 18.5765 26.1521 20.9778C26.1521 23.379 24.2252 25.3256 21.8482 25.3256C19.4713 25.3256 17.5444 23.379 17.5444 20.9778Z",
    fill: "#3D87BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 30.8364C14 28.7176 15.7002 27 17.7975 27H18.1427C18.3295 27 18.5151 27.0298 18.6927 27.0884L19.5692 27.3776C21.05 27.866 22.6462 27.866 24.127 27.3776L25.0035 27.0884C25.1811 27.0298 25.3668 27 25.5536 27H25.8988C27.9961 27 29.6963 28.7176 29.6963 30.8364V32.052C29.6963 32.8226 29.1435 33.4796 28.3907 33.6038C24.0577 34.3185 19.6386 34.3185 15.3056 33.6038C14.5528 33.4796 14 32.8226 14 32.052V30.8364Z",
    fill: "#3D87BF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8423 15.5682C23.6317 14.61 24.8213 14 26.1518 14C28.5287 14 30.4556 15.9466 30.4556 18.3479C30.4556 20.4482 28.9814 22.2007 27.0214 22.607C27.1841 22.0859 27.2719 21.5312 27.2719 20.9558C27.2719 18.2727 25.363 16.04 22.8423 15.5682ZM24.6276 25.6917L24.5182 25.7264C24.8964 25.5099 25.2463 25.2488 25.561 24.9502C26.525 25.0288 27.5006 24.9147 28.4307 24.6079L29.3072 24.3187C29.4848 24.2601 29.6704 24.2303 29.8573 24.2303H30.2024C32.2997 24.2303 33.9999 25.9479 33.9999 28.0667V29.2823C33.9999 30.0529 33.4471 30.7099 32.6943 30.8341C32.0379 30.9423 31.3796 31.0342 30.7199 31.1097V30.3673C30.7199 27.7242 28.5126 25.5814 25.7899 25.5814H25.3417C25.0992 25.5814 24.8582 25.6187 24.6276 25.6917Z",
    fill: "#3D87BF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveAdmins);
export default __webpack_public_path__ + "static/media/active-admins.e0a81c56ac01203b0a4d4e1a735e9533.svg";
export { ForwardRef as ReactComponent };